<script lang="ts">
import { defineComponent, h, Transition } from 'vue';

export default defineComponent({
    name: 'HeightTransition',

    setup(_, { attrs, slots }) {
        return () =>
            h(
                Transition,
                {
                    name: 'height-transition',
                    ...attrs,
                    onBeforeEnter(el: Element) {
                        (el as HTMLElement).style.height = '0';
                    },
                    onEnter(el: Element) {
                        const element = el as HTMLElement;
                        element.style.height = `${element.scrollHeight}px`;
                    },
                    onAfterEnter(el: Element) {
                        (el as HTMLElement).style.height = '';
                    },
                    onLeave(el: Element) {
                        const element = el as HTMLElement;
                        element.style.height = window.getComputedStyle(element).height;

                        setTimeout(() => {
                            element.style.height = '0';
                        });
                    },
                    onAfterLeave(el: Element) {
                        (el as HTMLElement).style.height = '';
                    },
                },
                slots,
            );
    },
});
</script>
